import { render } from "./reportEatXfbm.vue?vue&type=template&id=67ffde38"
import script from "./reportEatXfbm.vue?vue&type=script&lang=js"
export * from "./reportEatXfbm.vue?vue&type=script&lang=js"

import "./reportEatXfbm.vue?vue&type=style&index=0&id=67ffde38&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__